import { Controller } from "@hotwired/stimulus"

// P17 — « Reprendre le vainqueur / le perdant » remplit le select VIDE
// du formulaire de composition : Paire 1 d'abord, Paire 2 si Paire 1
// est déjà prise (les deux pleins : Paire 2 est remplacée — l'intention
// la plus récente désigne l'adversaire). Sans rechargement : le
// formulaire (turbo-permanent) garde tout son état. Le tour proposé ne
// s'applique que si aucun tour n'est déjà choisi.
// Sans JavaScript, le href du lien reste le préremplissage serveur.
export default class extends Controller {
  static values = { team: String, round: String }

  apply(event) {
    const form = document.getElementById("composition_form")
    const t1 = form?.querySelector("select[name='match[team1_id]']")
    const t2 = form?.querySelector("select[name='match[team2_id]']")
    if (!t1 || !t2) return

    event.preventDefault()
    const target = t1.value ? t2 : t1
    target.value = this.teamValue

    const round = form.querySelector("select[name='match[round_id]']")
    if (round && this.roundValue && !round.value) round.value = this.roundValue

    form.scrollIntoView({ behavior: "smooth", block: "center" })
    target.classList.add("ring-2", "ring-emerald-400")
    setTimeout(() => target.classList.remove("ring-2", "ring-emerald-400"), 1200)
  }
}
